module.exports = __webpack_public_path__ + "static/media/poster_mat.579f1ca3.png";